import React from 'react';
import { AgentMessage } from 'types';

type ComponentProps = { message: AgentMessage };

const AgentChatMessage: React.FC<ComponentProps> = ({ message }) => {
  const userMessageClass = 'self-end  bg-litlingo-info-light';
  const agentMessageClass = 'self-start bg-litlingo-gray-1';

  const messageClass = message.role === 'user' ? userMessageClass : agentMessageClass;

  return (
    <div
      className={`mx-2 min-w-14 max-w-4/5 py-1 px-2 flex justify-center rounded ${messageClass}`}
    >
      <span>{message.content}</span>
    </div>
  );
};

export default AgentChatMessage;
